// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Computational_home {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.Computational_container {
  padding: 100px 0px;
}
/* .middle_con {
  position: absolute;
  width: 100%;
  bottom: 15%;
} */
.middle_con p {
  font-size: 22px;
  font-weight: 600;
  width: 90%;
}
.Computational_home .content {
  width: 35%;
  text-align: left;
}
.wrapper {
  position: relative;
  width: 500px;
  height: 500px;
  border: 1px solid #ccc;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  border: none;
}

.sector {
  position: absolute;
  transform-origin: 100% 100%;
  background: #ccc;
  width: 500px;
  height: 500px;
  left: 50%;
  top: 50%;
  margin-top: -500px;
  margin-left: -500px;
  cursor: pointer;
}

.sector:hover {
  background: #000;
}
#sec1 {
  transform: rotate(72deg) skew(18deg);
  background: #febc08;
}
#sec1 img {
  transform: skew(-18deg) rotate(285deg);
  margin: 87px 100px;
}
#sec2 {
  transform: rotate(144deg) skew(18deg);
  background: #08b9fc;
}
#sec2 img {
  transform: skew(-18deg) rotate(214deg);
  margin: 87px 100px;
}
#sec3 {
  transform: rotate(216deg) skew(18deg);
  background: #2d85f5;
}
#sec3 img {
  transform: skew(-18deg) rotate(145deg);
  margin: 87px 100px;
}
#sec4 {
  transform: rotate(288deg) skew(18deg);
  background: #6e5ac8;
}
#sec4 img {
  transform: skew(-18deg) rotate(70deg);
  margin: 87px 100px;
}
#sec5 {
  transform: rotate(360deg) skew(18deg);
  background: #e20f6f;
}
#sec5 img {
  transform: skew(-18deg) rotate(358deg);
  margin: 87px 100px;
}

.content {
  margin-left: 20px;
}
.tab-content.active {
  display: block;
}
.middle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  height: 60%;
  border-radius: 50%;
  background: linear-gradient(
      to right,
      #febc07,
      #09b9fc,
      #2d85f5,
      #6e5ac8,
      #e20f6f
    )
    border-box;
  border: 10px solid transparent;
}
.middle_con {
  position: absolute;
  display: flex;
  background: #fff;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  top: 0px;
}
.middle img {
  padding: 20px;
  width: 40%;
}
#sec1 img,
#sec2 img,
#sec3 img,
#sec4 img,
#sec5 img {
  width: 14%;
  position: absolute;
  bottom: 0px;
  object-fit: contain;
}
/* .sector.active {
  box-shadow: inset 30px 2px 100px 10px #00000021;
} */

.sector.active {
  box-shadow: inset 0 0 16px 2px #00000099;
}
@media (max-width: 576px) {
  .Computational_container {
    padding: 50px 0px;
  }
  .middle_con p {
    font-size: 18px;
  }
  .Computational_home {
    flex-direction: column;
  }
  .wrapper {
    width: 300px;
    height: 300px;
  }
  .sector {
    width: 100%;
    height: 300px;
    margin-top: -100%;
    margin-left: -300px;
  }
  #sec1 img {
    margin: 45px 55px;
  }
  #sec2 img {
    margin: 45px 50px;
  }
  #sec4 img {
    margin: 44px 50px;
  }
  #sec3 img {
    margin: 50px 60px;
  }

  #sec5 img {
    margin: 50px 50px;
  }
  .Computational_home .content {
    width: 100%;
    padding: 40px 20px;
    text-align: left;
  }
}
@media only screen and (min-width: 576px) and (max-width: 920px) {
  .wrapper {
    width: 400px;
    height: 400px;
  }
  .sector {
    width: 400px;
    height: 400px;
    margin-top: -400px;
    margin-left: -400px;
  }
  .Computational_home .content {
    width: 50%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/home/Computational.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;;;;GAIG;AACH;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAET,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB;;;;;;;;cAQY;EACZ,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;;;;;EAKE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;AACA;;GAEG;;AAEH;EACE,wCAAwC;AAC1C;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".Computational_home {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-around;\r\n}\r\n.Computational_container {\r\n  padding: 100px 0px;\r\n}\r\n/* .middle_con {\r\n  position: absolute;\r\n  width: 100%;\r\n  bottom: 15%;\r\n} */\r\n.middle_con p {\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n  width: 90%;\r\n}\r\n.Computational_home .content {\r\n  width: 35%;\r\n  text-align: left;\r\n}\r\n.wrapper {\r\n  position: relative;\r\n  width: 500px;\r\n  height: 500px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 50%;\r\n  position: relative;\r\n  overflow: hidden;\r\n  border: none;\r\n}\r\n\r\n.sector {\r\n  position: absolute;\r\n  transform-origin: 100% 100%;\r\n  background: #ccc;\r\n  width: 500px;\r\n  height: 500px;\r\n  left: 50%;\r\n  top: 50%;\r\n  margin-top: -500px;\r\n  margin-left: -500px;\r\n  cursor: pointer;\r\n}\r\n\r\n.sector:hover {\r\n  background: #000;\r\n}\r\n#sec1 {\r\n  transform: rotate(72deg) skew(18deg);\r\n  background: #febc08;\r\n}\r\n#sec1 img {\r\n  transform: skew(-18deg) rotate(285deg);\r\n  margin: 87px 100px;\r\n}\r\n#sec2 {\r\n  transform: rotate(144deg) skew(18deg);\r\n  background: #08b9fc;\r\n}\r\n#sec2 img {\r\n  transform: skew(-18deg) rotate(214deg);\r\n  margin: 87px 100px;\r\n}\r\n#sec3 {\r\n  transform: rotate(216deg) skew(18deg);\r\n  background: #2d85f5;\r\n}\r\n#sec3 img {\r\n  transform: skew(-18deg) rotate(145deg);\r\n  margin: 87px 100px;\r\n}\r\n#sec4 {\r\n  transform: rotate(288deg) skew(18deg);\r\n  background: #6e5ac8;\r\n}\r\n#sec4 img {\r\n  transform: skew(-18deg) rotate(70deg);\r\n  margin: 87px 100px;\r\n}\r\n#sec5 {\r\n  transform: rotate(360deg) skew(18deg);\r\n  background: #e20f6f;\r\n}\r\n#sec5 img {\r\n  transform: skew(-18deg) rotate(358deg);\r\n  margin: 87px 100px;\r\n}\r\n\r\n.content {\r\n  margin-left: 20px;\r\n}\r\n.tab-content.active {\r\n  display: block;\r\n}\r\n.middle {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  -webkit-transform: translate(-50%, -50%);\r\n  transform: translate(-50%, -50%);\r\n  width: 60%;\r\n  height: 60%;\r\n  border-radius: 50%;\r\n  background: linear-gradient(\r\n      to right,\r\n      #febc07,\r\n      #09b9fc,\r\n      #2d85f5,\r\n      #6e5ac8,\r\n      #e20f6f\r\n    )\r\n    border-box;\r\n  border: 10px solid transparent;\r\n}\r\n.middle_con {\r\n  position: absolute;\r\n  display: flex;\r\n  background: #fff;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 50%;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  top: 0px;\r\n}\r\n.middle img {\r\n  padding: 20px;\r\n  width: 40%;\r\n}\r\n#sec1 img,\r\n#sec2 img,\r\n#sec3 img,\r\n#sec4 img,\r\n#sec5 img {\r\n  width: 14%;\r\n  position: absolute;\r\n  bottom: 0px;\r\n  object-fit: contain;\r\n}\r\n/* .sector.active {\r\n  box-shadow: inset 30px 2px 100px 10px #00000021;\r\n} */\r\n\r\n.sector.active {\r\n  box-shadow: inset 0 0 16px 2px #00000099;\r\n}\r\n@media (max-width: 576px) {\r\n  .Computational_container {\r\n    padding: 50px 0px;\r\n  }\r\n  .middle_con p {\r\n    font-size: 18px;\r\n  }\r\n  .Computational_home {\r\n    flex-direction: column;\r\n  }\r\n  .wrapper {\r\n    width: 300px;\r\n    height: 300px;\r\n  }\r\n  .sector {\r\n    width: 100%;\r\n    height: 300px;\r\n    margin-top: -100%;\r\n    margin-left: -300px;\r\n  }\r\n  #sec1 img {\r\n    margin: 45px 55px;\r\n  }\r\n  #sec2 img {\r\n    margin: 45px 50px;\r\n  }\r\n  #sec4 img {\r\n    margin: 44px 50px;\r\n  }\r\n  #sec3 img {\r\n    margin: 50px 60px;\r\n  }\r\n\r\n  #sec5 img {\r\n    margin: 50px 50px;\r\n  }\r\n  .Computational_home .content {\r\n    width: 100%;\r\n    padding: 40px 20px;\r\n    text-align: left;\r\n  }\r\n}\r\n@media only screen and (min-width: 576px) and (max-width: 920px) {\r\n  .wrapper {\r\n    width: 400px;\r\n    height: 400px;\r\n  }\r\n  .sector {\r\n    width: 400px;\r\n    height: 400px;\r\n    margin-top: -400px;\r\n    margin-left: -400px;\r\n  }\r\n  .Computational_home .content {\r\n    width: 50%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
